
import {Component, Vue} from 'vue-property-decorator';
import {readAdminForms, readAdminGroups} from '@/store/admin/getters';
import {dispatchDeleteGroup, dispatchGetFormsAdmin, dispatchGetGroups} from '@/store/admin/actions';
import DynamicTable from '@/components/datatables/DynamicTable.vue';
import {SpecialFields} from '@/interfaces/constants';

@Component({
  components: {DynamicTable},
})
export default class GroupList extends Vue {

  private headers = [
    {text: this.$t('action'), value: 'action', align: 'center', filterable: false, sortable: false,
      router_name: 'main-admin-group-edit', width: '100px', delete_function: this.deleteGroup},
    {
      text: this.$t('name'),
      sortable: true,
      value: 'name',
      align: 'left',
    },
    {
      text: this.$t('observations'),
      sortable: false,
      value: 'observations',
      align: 'left',
    },
    {
      text: this.$t('permissions'),
      sortable: true,
      value: 'permissions',
      align: 'center',
      special_field: SpecialFields.PermissionVisualizer,
    },
    {
      text: this.$t('forms'),
      sortable: true,
      value: 'forms',
      align: 'center',
      special_field: SpecialFields.FormsVisualizer,
    },
  ];

  get groups() {
    return readAdminGroups(this.$store);
  }

  public async mounted() {
    await dispatchGetGroups(this.$store);
  }

  public async deleteGroup(id) {
    await dispatchDeleteGroup(this.$store, id);
    await dispatchGetGroups(this.$store);
  }

}
